const fields = [
  // Neutral fields
  {
    key: 'name',
    type: 'input',
    templateOptions: {
      label: 'title'
    }
  },
  {
    key: 'startDate',
    type: 'datepicker',
    templateOptions: {
      label: 'startDate'
    }
  },
  {
    key: 'endDate',
    type: 'datepicker',
    templateOptions: {
      label: 'endDate'
    }
  },
  {
    key: 'hasFullDateOfBirth',
    type: 'boolean',
    templateOptions: {
      label: 'fullDateOfBirthRequired'
    }
  },
  {
    key: 'hasRequiredPlayerIdentificationNumber',
    type: 'boolean',
    templateOptions: {
      label: 'hasRequiredPlayerIdentificationNumber'
    }
  },
  {
    key: 'playerIdentificationNumberInputLabel',
    type: 'input',
    templateOptions: {
      label: 'playerIdentificationNumberInputLabel'
    },
    display: (field, model) => model.hasRequiredPlayerIdentificationNumber
  },
  {
    key: 'collectPlayerPositions',
    type: 'boolean',
    templateOptions: {
      label: 'collectPlayerPositions'
    },
    display: (field, model) => (model.availablePlayerPositions || []).length > 0
  },
  {
    key: 'collectPlayerTags',
    type: 'boolean',
    templateOptions: {
      label: 'collectPlayerTags'
    }
  },
  {
    key: 'description',
    type: 'html',
    templateOptions: {
      label: 'description'
    }
  },
  {
    key: 'teamApplicationEnabled',
    type: 'boolean',
    templateOptions: {
      label: 'teamApplicationEnabled'
    }
  },
  {
    key: 'freeAgentApplicationEnabled',
    type: 'boolean',
    templateOptions: {
      label: 'freeAgentApplicationEnabled'
    }
  }
]

export default fields
